import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody} from 'reactstrap'
import './modal.css'

class ModalWindow extends Component {
  constructor(props) {
    super(props)
    this.state = { modal: this.props.isOpen }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setState({ modal: nextProps.isOpen })
  }

  toggle = () => {
    this.setState({ modal: !this.state.modal })
    if (typeof this.props.onClose !== 'undefined') this.props.onClose()
  }

  render() {
    const {children} = this.props
    return (
      <div>
        <Modal
          className='modalVideos'
          isOpen={this.state.modal}
          toggle={this.toggle}
          size={this.props.size ? this.props.size : 'lg'}
          backdrop={true}
          keyboard={true}
        >
          <ModalHeader toggle={this.toggle} className='modal-window'>
            <span className='modalTitle'>
              <i className={this.props.icon} style={{color: 'rgb(74, 144, 226)', marginRight: '5px'}}></i>
              {this.props.title}
            </span>
          </ModalHeader>

          <ModalBody>
            <div className="pb-lightbox">
              <button className="pb-lightbox-close" onClick={this.toggle} aria-label="Close video">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.3019 16.6146L4.09359 26.8229C3.71164 27.2049 3.22553 27.3958 2.63525 27.3958C2.04498 27.3958 1.55887 27.2049 1.17692 26.8229C0.794976 26.441 0.604004 25.9549 0.604004 25.3646C0.604004 24.7743 0.794976 24.2882 1.17692 23.9063L11.3853 13.6979L1.17692 3.48958C0.794976 3.10764 0.604004 2.62153 0.604004 2.03125C0.604004 1.44097 0.794976 0.954861 1.17692 0.572917C1.55887 0.190972 2.04498 0 2.63525 0C3.22553 0 3.71164 0.190972 4.09359 0.572917L14.3019 10.7813L24.5103 0.572917C24.8922 0.190972 25.3783 0 25.9686 0C26.5589 0 27.045 0.190972 27.4269 0.572917C27.8089 0.954861 27.9998 1.44097 27.9998 2.03125C27.9998 2.62153 27.8089 3.10764 27.4269 3.48958L17.2186 13.6979L27.4269 23.9063C27.8089 24.2882 27.9998 24.7743 27.9998 25.3646C27.9998 25.9549 27.8089 26.441 27.4269 26.8229C27.045 27.2049 26.5589 27.3958 25.9686 27.3958C25.3783 27.3958 24.8922 27.2049 24.5103 26.8229L14.3019 16.6146Z" fill="#979797"/>
                </svg>
              </button>

              <div className="pb-lightbox-frame">
                {children}
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default ModalWindow
